import { render, staticRenderFns } from "./inventoryDealsTable.vue?vue&type=template&id=2ebf97cc&lang=pug"
import script from "./inventoryDealsTable.vue?vue&type=script&lang=js"
export * from "./inventoryDealsTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports